/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_appsync_graphqlEndpoint": "https://73vozb6lsvburk4qqtgyxjycsu.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "stripeapi",
            "endpoint": "https://ogc4ykjbce.execute-api.eu-central-1.amazonaws.com/main",
            "region": "eu-central-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-central-1:4281384c-1e67-40c0-b77c-6b4fe563fbcc",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_jTmJkcrv1",
    "aws_user_pools_web_client_id": "57rkearhunq95rkof56hu7mkua",
    "oauth": {
        "domain": "doonationefcd9d03-efcd9d03-main.auth.eu-central-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://dashboard.dooonation.com/,https://dashboard.dooonation-dev.com/",
        "redirectSignOut": "https://dashboard.dooonation.com/,https://dashboard.dooonation-dev.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "doonationbucket104030-main",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
